import { DEALER_SETTINGS_DEFAULT } from 'constants/constants';
import { useAppSelector } from 'store/hooks';

export const useDealerPageSize = () => {
  const userSettings: any = useAppSelector(
    (state) => state.auth.data.user.userSettings
  );
  return userSettings?.pageSize || DEALER_SETTINGS_DEFAULT.pageSize;
};
